import React from "react";
import CardSimple from "../../../../components/basic/CardSimple";

const PriceMatrix = () => {
  return (
    <CardSimple>
      <div id="add-price-matrix">
        <br />
        <div>
          <div className="support-wrapper support-manual">
            <h2>Add a Price Matrix</h2>
            <ul>
              <li>Go to Menu > Pricing > Price Setting</li>
              <img src={require("./SupportDocImages/measurement_setting_images/measurement_setting.PNG")} />
              <li>Click on 'Add New Price Matrix'</li>
              <img src="http://techpos.ca/support-images/PriceMatrix/PriceMatrix-2.png" />
              <li>
                Under Price Matrix info, type the name and toggle the button to set
                it to active or inactive.
              </li>
              <img
                src="http://techpos.ca/support-images/PriceMatrix/PriceMatrix-3.png"
                width="600"
              />
              <li>Under Settings Info, set the price per weight</li>
              <img
                src="http://techpos.ca/support-images/PriceMatrix/PriceMatrix-4.png"
                width="600"
              />
              <li>
                In the last column, you can determine which weight settings
                are part of an active campaign (by default they are inactive).
                To activate them, just toggle the button.
              </li>
              <img src="http://techpos.ca/support-images/PriceMatrix/PriceMatrix-5.png" />
              <li>Click on Save</li>
            </ul>
          </div>
        </div>
        <div id="edit-price-matrix">
          <br />
          <hr />
          <div className="support-wrapper support-manual">
            <h2>Edit a Price Matrix</h2>
            <ul>
              <li>Go to Menu > Pricing > Price Setting</li>
              <img src={require("./SupportDocImages/measurement_setting_images/measurement_setting.PNG")} />
              <li>Click on the Edit button next to the desired Matrix.</li>
              <img src="http://techpos.ca/support-images/PriceMatrix/PriceMatrix-6.png" />
              <li>
                Modify the information you need to. Once you are done,
                click on Save. 
              </li>
            </ul>
          </div>
        </div>
      </div>
    </CardSimple>
  );
};

export default PriceMatrix;
